// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wfm-task-progress {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
}

wfm-plan-loading-overlay {
  background: white;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 50;
}

.toolbar-container {
  justify-content: space-between;
}

.table-list {
  border: 1px solid #c1bebe;
}

.mu-multiselect {
  min-width: 250px;
}

:host ::ng-deep .toolbar-container button.btn {
  margin: 0px 8px 0 0;
}

.icon {
  font-size: 20px;
}

.action-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
}

:host ::ng-deep .ag-header-cell {
  color: #98A2B3;
  font-weight: bold;
}

:host ::ng-deep .ag-ltr .ag-row-group-leaf-indent {
  --ag-row-group-indent-size:0;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
